/**
 * @param  {string} id Content Asset ID
 * @returns {string} Content Asset content or empty string
 */
async function getContentAsset(id) {
  const { default: getFrontConfig } = require('../getFrontConfig');
  const urlUtils = require('./url');
  const FRONT_CONFIG = getFrontConfig();

  const contentAssetUrl = urlUtils.urlWithSearchParams(
    FRONT_CONFIG.urls.getContentAssetUrl,
    {
      id,
    }
  );

  return fetch(contentAssetUrl, {
    method: 'get',
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        return data.content;
      }
      return '';
    })
    .catch(() => '');
}

module.exports = {
  getContentAsset,
};
